// src/config/environment.ts
export const ENV = {
  APP_NAME: "Lrnsy",
  APP_URL:
    process.env.NODE_ENV === "production"
      ? "https://lrnsy.electrixitaty.com"
      : "http://192.168.100.5:3000",

  // Supabase (stays the same)
  SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL || "",
  SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY || "",

  // Firebase (new)
  FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY || "",
  FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  FIREBASE_MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID || "",

  // Payments
  IPINFO_TOKEN: "",
  PAYSTACK_PUBLIC_LIVE_KEY: process.env.REACT_APP_PAYSTACK_PUBLIC_LIVE_KEY || "",
  PAYSTACK_PUBLIC_TEST_KEY: process.env.REACT_APP_PAYSTACK_PUBLIC_TEST_KEY || "",
  FLUTTERWAVE_PUBLIC_KEY: process.env.REACT_APP_FLUTTERWAVE_PUBLIC_KEY || "",

  // App Settings
  CARD_EXPIRY_DAYS: 30,
  MAX_BOUQUET_ITEMS: 50,
  PLATFORM_FEE: 1000,
  APP_CURRENCY: "KES",
} as const;

// Validate environment variables
const requiredEnvVars = [
  "REACT_APP_SUPABASE_URL",
  "REACT_APP_SUPABASE_ANON_KEY",
  "REACT_APP_FIREBASE_API_KEY",
  "REACT_APP_FIREBASE_AUTH_DOMAIN",
  "REACT_APP_FIREBASE_PROJECT_ID",
] as const;

requiredEnvVars.forEach((envVar) => {
  if (!process.env[envVar]) {
    throw new Error(`${envVar} is required but not defined`);
  }
});
